module.exports = __webpack_public_path__ + "img/71ne.e6dcc91a.svg";